/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-var */
/* eslint-disable import/prefer-default-export */
/* eslint-disable no-undef */
import Web3 from 'web3';
import axios from 'axios';
import { ENVIRONMENT } from 'configs';
import NFTContract from 'configs/abis/NFTMarketplace.json';
import toast from 'react-hot-toast';

var web3 = new Web3(
  Web3.givenProvider || 'ws://some.local-or-remote.node:8546'
);
//
export const getMyNFTs = async () => {
  const contract = new web3.eth.Contract(
    NFTContract.abi,
    ENVIRONMENT.CONTRACT_ADDRESS
  );
  const account = await web3.eth.getAccounts();
  const items = await contract.methods.getMyNFTs().call({ from: account[0] });
  const allItems = await Promise.all(
    items.map(async (i) => {
      const tokenUri = await contract.methods.tokenURI(i.tokenId).call();
      const item = await axios.get(`https://ipfs.io/ipfs/${tokenUri}`);
      return {
        token_id: i.tokenId,
        name: item.data.name,
        description: item.data.description,
        external: item.data.external,
        image: item.data.image,
        price: i.price,
        sold: i.sold,
        seller: i.seller,
        currentOwner: i.holder,
      };
    })
  );
  return allItems;
};

export const resellNFT = async (data) => {
  const account = await web3.eth.getAccounts();
  if (account.length !== 0) {
    const contract = new web3.eth.Contract(
      NFTContract.abi,
      ENVIRONMENT.CONTRACT_ADDRESS
    );
    const res = await contract.methods
      .resellNFTToken(data.tokenId, Web3.utils.toWei(data.price, 'ether'))
      .send({ from: account[0], value: Web3.utils.toWei('0.0025', 'ether') });
    return res;
  }
  return toast('Connect your wallet before purchase.', {
    position: 'bottom-center',
    icon: '⚠️',
  });
};
